import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/* eslint-disable react/prop-types */

import React from 'react';
import styled from 'styled-components';
import { buttonBase } from "../../styles/mixins/buttons"; // eslint-disable-next-line prefer-arrow-callback

export default styled(React.forwardRef(function Button(_ref, ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'button' : _ref$component,
      variantRules = _ref.variantRules,
      buttonSize = _ref.buttonSize,
      condensed = _ref.condensed,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      props = _objectWithoutProperties(_ref, ["component", "variantRules", "buttonSize", "condensed", "hover", "active", "focus"]);

  return React.createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Button",
  componentId: "oyfj48-0"
})(["", ";"], function (props) {
  return buttonBase({
    buttonSize: props.buttonSize,
    condensed: props.condensed,
    variantRules: props.variantRules
  });
});